<template>
  <div class="container">
     <div class="topDiv" v-if="!isXiajia">
        <div class="swiper" v-if="shopDetail&& shopDetail.pictList&& shopDetail.pictList.length>1">
              <swiper class="slider" :options="options">
                <swiper-slide v-for="(item,index) in shopDetail.pictList" :key="index">
                  <img :src="item.pictUrl" class="slide_image" @click="viewBigPic(item.pictUrl)" />
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
              </swiper>
        </div>
        <div class="swiper" v-else>
            <img v-if="shopDetail&& shopDetail.pictList&& shopDetail.pictList.length==1" :src="shopDetail.pictList[0].pictUrl" class="slide_image" @click="viewBigPic(shopDetail.pictList[0].pictUrl)" />
        </div>

        <div class="top_item">
            <div class="top_item_left">
                  <img class="top_item_left_icon" :src="shopDetail.logUrl" />
            </div>
            <div class="top_item_right">
                  <span class="top_item_right_span1">{{shopDetail.brandName}}</span>
                  <img @click="shareFun" src="../../assets/images/icon_share.png" class="icon_share">
                  <div class="top_item_right_div1">
                        <span class="top_item_right_span3"  v-for="(sitem,sindex) in shopDetail.discountList" :key="sindex">{{sitem}}</span>
                  </div>
                  <div class="top_item_right_div1">
                        <span class="top_item_right_span4"  v-for="(sitem,sindex) in shopDetail.tagNameList" :key="sindex">#{{sitem}}</span>
                  </div>
            </div>
        </div>

        <div class="body_items">
           <div class="body_item" v-if="shopDetail.address">
                <img class="body_item_left_icon" src="../../assets/images/icon_site.png" />
                <span class="body_item_span">{{shopDetail.address}}</span>
                <!-- btn_duplicate.png -->
                <img class="body_item_right_icon" src="../../assets/images/btn_duplicate.png" @click="copyAddress()" :data-clipboard-text="shopDetail.address" />
           </div>
           <div class="body_line" v-if="shopDetail.tel"></div>
           <div class="body_item" @click="callPhone" v-if="shopDetail.tel">
                <img class="body_item_left_icon" src="../../assets/images/icon_iphone_2.png" />
                <span class="body_item_span">{{shopDetail.tel}}</span>
           </div>
           <div class="body_line" v-if="shopDetail.dateDt"></div>
           <div class="body_item" v-if="shopDetail.dateDt">
                <img class="body_item_left_icon" src="../../assets/images/icon_bianTime@2x.png" />
                <span class="body_item_span">营业时间: {{shopDetail.dateDt}}</span>
           </div>
        </div>

        <div class="detiail" v-if="shopDetail.content">
            <span class="detiail_title">商铺详情</span>
            <div class="body-span-body" v-html="shopDetail.content"></div>
        </div>

     </div>

     <div v-if="isXiajia" class="noMess">
        <img class="noMess_icon" src="../../assets/images/img_unpublish.png"/>
        <span class="noMess_span">该商铺已下架</span>
      <!-- <span class="btn" bindtap="toIndex">返回首页</span> -->
    </div>

     <fade-animation>
        <common-gallary
          :imgs="imgsArr"
          v-show="showGallary"
          @close="handleGallaryClose"
        ></common-gallary>
    </fade-animation>
    <share-iframe :showIframe="showIframe" @hideIframe="hideIframe"></share-iframe>
  </div>
</template>

<script>

import { getShopsInfo} from "../../utils/api";
import util from "../../utils/util";
import CommonGallary from '../../components/Gallary'
import FadeAnimation from '../../components/FadeAnimation'
import ShareIframe from '../../components/shareIframe';
import { mapState } from 'vuex';
import Clipboard from "clipboard";
import wx from 'weixin-js-sdk'
//import wx from 'jweixin-1.6.0'
export default {
  name: 'comReport',
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  components: {
     CommonGallary,
     FadeAnimation,
     ShareIframe
  },
  data () {
    return {
      shopID:"",
      isXiajia:false,
      shopDetail:'',
      imgsArr:[],
      showGallary:false,
      showIframe:false,
      options: {
        pagination: ".swiper-pagination",
        // paginationType: "fraction",
        paginationType: "bullets",
          // bulletClass : 'my-bullet',//需设置.my-bullet样式
          // bulletActiveClass: 'my-bullet-active',
          observeParents: true,
          autoplay: 3000,
          speed: 1000,
          loop:true,
          observer: true,
          // zoom: {
          //   maxRatio: 3, //最大倍数
          //   minRatio: 1, //最小倍数
          //   toggle: false //不允许双击缩放，只允许手机端触摸缩放。
          // }
      },


    }
  },

  created() {
    //this.getNoticeListAction();
  },
  activated () {
    if (this.shopID !== this.$route.params.id) {
      this.shopID =  this.$route.params.id;
      //this.getNoticeDetailAction();
      console.log(this.shopID);
      this.getShopsInfo();
    }
  },

  methods: {
    shareFun(){
      this.showIframe = true
    },
    hideIframe(){
      this.showIframe = false
    },
    copyAddress(){
      var clipboard = new Clipboard(".body_item_right_icon");
      clipboard.on("success", () => {
        util.showToast("复制成功");
        // 释放内存
        clipboard.destroy();
      });
    },
     handleGallaryClose () {
      this.showGallary = false
    },
    viewBigPic(pic){
      console.log(pic);
      this.imgsArr = [];
      this.imgsArr.push(pic)
      for(var i=0;i<this.shopDetail.pictList.length;i++){
         if(this.shopDetail.pictList[i].pictUrl!=pic){
           this.imgsArr.push(this.shopDetail.pictList[i].pictUrl)
         }
      }
      this.showGallary = true;
    },
    getShopsInfo(){
        let params = {
          id : this.shopID,
        }
        getShopsInfo(params).then(res => {
          if (res.res.code === 10000) {
            var item = res.body.shopsInfo;
            this.isXiajia =false;
            if(item.tagNames){
              var tels=item.tagNames.split(/[\n\s+,，；;]/g);
              for (var i = 0; i < tels.length; i++) {
                  if (tels[i] == "") {
                      // 删除数组中空值
                      tels.splice(i, 1);
                      i--;
                  }
              }
              item.tagNameList =tels;
            }
              if(item.discount){
                  item.discountList =item.discount.split(",");
              }
            this.shopDetail =item;
            var self =this;
            let address = window.location.href.split('?')[0];
            wx.ready(()=>{
              let obj = {
                title: item.brandName, // 分享标题
                desc: item.discount,
                link: address+'?marketId='+self.common.marketInfo.id+'&cityId='+self.common.cityId, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: item.logUrl,// 分享图标
                success:function(){
                  self.showIframe = false
                  util.showToast('已分享')
                }
              }
              wx.onMenuShareAppMessage(obj)
              wx.onMenuShareTimeline(obj)
          })
        }else{
          this.isXiajia =true;
        }
      });
    },
    callPhone () {
      if (this.shopDetail.tel) {
        window.location.href = 'tel://' + this.shopDetail.tel;
      }
    },
  }

  };
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.container {
  // height: 100vh;
  background-color: #EDEDED;
  position: relative;
  .flex(column);
}
.topDiv{
  //height: 500px;
  width: 100%;
  flex-direction: row;
}

//轮播图
.swiper{
    width: 100%;
    height: 500px;
    display: flex;
    background-color: #f5f5f5;
    position: relative;
}
.slider{
    width:100%;
    height: 500px;
}
.slide_image{
  width:100%;height:100%;
}
.image{
    width:100%;
    height:500px;
    display: block;
}
//头部信息
.top_item{
    // margin-left: 20px;
    // margin-right: 20px;
    flex: 1;
    display: flex;
    flex-direction:row;
    background:rgba(255,255,255,1);
    // border-radius:8px;
    padding: 28px;
}
.top_item_left{
    width: 162px;
    margin-right: 20px;
    flex-direction: column;
    display: flex;
}
.top_item_left_icon{
     width: 162px;
     height: 162px;
}
.top_item_right{
    flex: 1;
    flex-direction: column;
    display: flex;
    position: relative;
}
.icon_share{
  position:absolute;
  top: 6px;
  right: 8px;
  width: 44px;
  height: 44px;
}

.top_item_right_span1{
    font-size:30px;
    width: 470px;
    font-weight:500;
    color:rgba(51,51,51,1);
    line-height:42px;
    // max-lines: 1;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // white-space: nowrap;
}
.top_item_right_span2{
    height:34px;
    width: 490px;
    font-size:24px;
    font-weight:400;
    color:rgba(102,102,102,1);
    line-height:34px;
    max-lines: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

}
.top_item_right_div1{
    margin-top: 14px;
    flex-direction: row;
}
.top_item_right_span3{
    // height:44px;
    padding-top: 3px;
    padding-bottom: 3px;
    border-radius:4px;
    border:2px solid rgba(252,63,86,0.5);
    font-size:24px;
    font-weight:400;
    color:rgba(252,63,86,1);
    line-height:36px;
    padding-left: 8px;
    padding-right: 8px;
    margin-right: 10px;
    margin-left: 1px;
    margin-bottom: 5px;
    display:inline-block;


}
.top_item_right_span4{
    padding-top: 3px;
    padding-bottom: 3px;
    border-radius:4px;
    background:rgba(235,239,245,1);
    font-size:24px;
    font-weight:500;
    color:rgba(60,100,159,1);
    line-height:36px;
    padding-left: 8px;
    padding-right: 8px;
    margin-right: 10px;
    margin-bottom: 5px;
    display:inline-block;

}


.body_items{
   flex-direction: column;
   margin-top: 14px;
   width: 100%;
   background-color: #fff;
}
.body_item{
  width: 100%;
  // height: 100px;
  padding-bottom: 30px;
  padding-top: 30px;
  display: flex;
  flex-direction: row;
  // align-items: center;
}
.body_item_left_icon{
    width: 32px;
    height: 32px;
    margin-left: 28px;
    margin-top:6px;
}
.body_item_right_icon{
    width: 44px;
    height: 44px;
    margin-left: 8px;

}
.noMess {
  flex-direction: column;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.noMess_icon{
  margin-top: 360px;
  display: flex;
  width: 280px;
  height: 280px;
}
.noMess_span{
  margin-top: 28px;
  display: flex;
  height:44px;
  font-size:32px;
  font-weight:400;
  color:rgba(153,153,153,1);
  line-height:44px;
}

.body_item_span{
  width: 600px;
  margin-left: 10px;
  // height:40px;
  font-size:28px;
  font-weight:400;
  display: flex;
  color:rgba(51,51,51,1);
  line-height:44px;
}
.body_line{
  display: flex;
  margin-left: 28px;
  margin-right: 28px;
  height:2px;
  background:rgba(234,234,234,1);
}
.detiail{
  width: 100%;
  display: flex;
  margin-top: 14px;
  flex-direction: column;
  background-color: #fff;
  padding-bottom: 28px;
}
.detiail_title{
  margin-top: 28px;
  margin-left: 28px;
  height:44px;
  font-size:32px;
  font-weight:500;
  color:rgba(51,51,51,1);
  line-height:44px;
}

.body-span-body{
  margin-left: 28px;
  margin-right: 28px;
  // width:694px;
//  font-size:28px;
//  font-weight:400;
//  color:rgba(51,51,51,1);
//  line-height:40px;
 margin-bottom: 20px;
 padding-top: 10px;
    /deep/ strong {
        font-weight: bold;
        .fontSize(15px);
        line-height: 50px;
    }
    /deep/ p,
    /deep/ span {
        .fontSize(14px);
        color: rgba(0, 0, 0, 0.9);
        line-height: 40px;
    }
    /deep/ img {
        max-width: 100%;
        min-width: 40%;
        margin: 10px auto;
        height: auto;
        display: block;
    }
    /deep/ figcaption {
        text-align: center;
        .fontSize(14px);
        line-height: 50px;
    }
    /deep/ tr,
    td,
    th {
        .fontSize(14px);
    }
}


/deep/ .swiper-pagination {
  color: #000;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0.2rem;
  display: inline-block;
  text-align: center;
  height: 0.44rem;
  line-height: 0.44rem;
  color: #fff;
  font-size: 0.24rem;
  .flex();
  justify-content: center;
  align-items: center;
  // background: rgba(0, 0, 0, 0.5);
  border-radius: 0.04rem;
  .swiper-pagination-current {
    // font-size: 0.28rem !important;
  }
  .swiper-pagination-bullet-active{ //指示点的颜色
    background: #fff;
    opacity: 1;
  }
}
</style>